@if (headerShow) {
  <rask-header id="pageHeader" size="1" noPadding><span>{{ pageTitle }}</span>
  @if (actionShow) {
    <rask-action-button [disabled]="actionDisabled" icon="fas fa-plus" (click)="action()" aid="buttonAction">
      <rask-header noPadding>{{ actionTitle }}</rask-header>
    </rask-action-button>
  }
  @if (!actionShow) {
    <div class="header-items">
      <ng-content select="[header]"></ng-content>
    </div>
  }
</rask-header>
}

@if (headerContentShow) {
  <div #headerContent class="page-header-content svea-search-panel">
    <ng-content select="[headerContent]"></ng-content>
  </div>
}

@if (contentShow) {
  <div class="page-content" [ngClass]="contentClass">
    <ng-content></ng-content>
  </div>
}

@if (footerShow) {
  <rask-footer id="pageFooter" class="page-footer">
    <ng-content select="[footerContent]" footerContent></ng-content>
    <ng-content select="[footerLeft]" footerLeft></ng-content>
  </rask-footer>
}
